module.exports = __webpack_public_path__ + "static/media/Utkarsha_Gore.ce45b0d0.jpg";